document.addEventListener('DOMContentLoaded', () => {
  const desktopMedia = window.matchMedia('(min-width: 1366px)');
  const isDesktop = () => desktopMedia.matches;

  function readMenuMarkup(kind) {
    const source = document.querySelector(
      `[data-header-menu-markup="${kind}"], [data-header-menu-markup="shared"]`
    );
    if (!source) return '';
    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      return '';
    }
  }

  function ensureMobileNav() {
    const mobileMenu = document.querySelector('.header__menu_mobile');
    if (!mobileMenu) return null;
    let mobileNav = mobileMenu.querySelector('.nav_items');
    if (mobileNav) return mobileNav;
    const markup = readMenuMarkup('mobile');
    if (!markup) return null;
    mobileMenu.insertAdjacentHTML('beforeend', markup);
    mobileMenu.dataset.menuMounted = 'true';
    return mobileMenu.querySelector('.nav_items');
  }

  function ensureDesktopNav() {
    const desktopMenu = document.querySelector('.header__menu_desktop');
    if (!desktopMenu) return null;
    if (desktopMenu.querySelector('.nav_items')) return desktopMenu;
    const markup = readMenuMarkup('desktop');
    if (!markup) return desktopMenu;
    desktopMenu.insertAdjacentHTML('beforeend', markup);
    desktopMenu.dataset.menuMounted = 'true';
    return desktopMenu;
  }

  // ---------- Mobile menu open / close ----------
  const openMenuMobile = document.querySelector('.header__gapfy .open_nav_items');
  const closeMenuMobile = document.querySelector('.header__gapfy .close_nav_items');

  function closeMobileNav() {
    const mobileNav = document.querySelector('.header__menu_mobile .nav_items');
    if (!mobileNav) return;
    mobileNav.removeAttribute('open');
    document.body.style.overflow = 'auto';
    if (openMenuMobile) openMenuMobile.setAttribute('aria-expanded', 'false');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(openMenuMobile);
  }

  if (openMenuMobile) {
    openMenuMobile.addEventListener('click', () => {
      const mobileNav = ensureMobileNav();
      if (!mobileNav) return;
      const mobileMenuWrap = mobileNav.closest('.header__menu_mobile') || mobileNav;
      mobileNav.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      openMenuMobile.setAttribute('aria-expanded', 'true');
      if (typeof trapFocus === 'function' && mobileMenuWrap) trapFocus(mobileMenuWrap);
    });
  }
  if (closeMenuMobile) {
    closeMenuMobile.addEventListener('click', closeMobileNav);
  }
  // Escape fecha o menu mobile
  document.addEventListener('keydown', (e) => {
    const mobileNav = document.querySelector('.header__menu_mobile .nav_items');
    if (e.key === 'Escape' && mobileNav && mobileNav.hasAttribute('open')) closeMobileNav();
  });

  function closeDesktopSubmenus() {
    document
      .querySelectorAll('.header__menu_desktop .nav_items [data-submenu]')
      .forEach((s) => s.setAttribute('closed', ''));
    document
      .querySelectorAll('.header__menu_desktop .nav_items [data-menu] > a[aria-expanded]')
      .forEach((a) => a.setAttribute('aria-expanded', 'false'));
  }

  // ---------- Mobile: tap a top-level item to open its submenu ----------
  document.addEventListener('click', (e) => {
    if (isDesktop() || !e.target.closest) return;
    const link = e.target.closest('.header__menu_mobile .nav_items [data-menu]');
    if (!link) return;

    const anchor = link.querySelector('a');
    if (anchor && anchor.getAttribute('href')) e.preventDefault();

    const idx = link.dataset.menu;
    const mobileNav = link.closest('.nav_items');
    const submenuMobile = mobileNav.querySelector(`[data-submenu="${idx}"]`);
    const mainLinks = mobileNav.querySelector('.main_items');
    if (submenuMobile) {
      submenuMobile.toggleAttribute('closed');
      if (mainLinks) mainLinks.toggleAttribute('closed');
    }

    mobileNav.querySelectorAll('[data-submenu]').forEach((submenu) => {
      if (submenu !== submenuMobile) submenu.setAttribute('closed', '');
    });
  });

  // ---------- Mobile: "back" buttons inside submenus ----------
  document.addEventListener('click', (e) => {
    if (!e.target.closest) return;
    const back = e.target.closest('.header__menu_mobile .submenu_back__container');
    if (!back) return;
    const submenu = back.closest('[data-submenu]');
    const mainLinks = back.closest('.nav_items')?.querySelector('.main_items');
    if (submenu) {
      submenu.toggleAttribute('closed');
      if (mainLinks) mainLinks.toggleAttribute('closed');
    }
  });

  // ---------- Desktop: hover opens the mega-menu (delayed close so links stay clickable) ----------
  function bindDesktopMenu() {
    const desktopMenu = ensureDesktopNav();
    if (!desktopMenu || desktopMenu.dataset.listenersBound === 'true') return;
    desktopMenu.dataset.listenersBound = 'true';
    let closeTimer = null;
    const cancelClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };
    const scheduleClose = () => {
      cancelClose();
      closeTimer = setTimeout(() => {
        if (isDesktop()) closeDesktopSubmenus();
      }, 280);
    };

    // Top-level items: hover opens its submenu; leaving starts the delayed close
    desktopMenu.querySelectorAll('.nav_items [data-menu]').forEach((li) => {
      li.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        cancelClose();
        const idx = li.dataset.menu;
        const submenu = document.querySelector(
          `.header__menu_desktop .nav_items [data-submenu="${idx}"]`
        );
        closeDesktopSubmenus();
        if (submenu) {
          submenu.removeAttribute('closed');
          const anchor = li.querySelector('a[aria-expanded]');
          if (anchor) anchor.setAttribute('aria-expanded', 'true');
        }
      });
      li.addEventListener('mouseleave', scheduleClose);
    });

    // The open submenu panel: entering it cancels the close (so you can reach the links);
    // leaving it schedules the close again.
    desktopMenu.querySelectorAll('.nav_items [data-submenu]').forEach((sub) => {
      sub.addEventListener('mouseenter', cancelClose);
      sub.addEventListener('mouseleave', scheduleClose);
    });

    // Teclado: focar um item de topo abre o submenu dele; sair do menu fecha; Escape fecha
    desktopMenu.addEventListener('focusin', (e) => {
      if (!isDesktop()) return;
      const li = e.target.closest('[data-menu]');
      if (li && desktopMenu.contains(li)) {
        cancelClose();
        const idx = li.dataset.menu;
        const submenu = document.querySelector(
          `.header__menu_desktop .nav_items [data-submenu="${idx}"]`
        );
        closeDesktopSubmenus();
        if (submenu) {
          submenu.removeAttribute('closed');
          const anchor = li.querySelector('a[aria-expanded]');
          if (anchor) anchor.setAttribute('aria-expanded', 'true');
        }
      } else if (!e.target.closest('[data-submenu]')) {
        closeDesktopSubmenus();
      }
    });
    desktopMenu.addEventListener('focusout', (e) => {
      if (!isDesktop()) return;
      if (!e.relatedTarget || !desktopMenu.contains(e.relatedTarget)) scheduleClose();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isDesktop()) closeDesktopSubmenus();
    });
  }

  if (isDesktop()) bindDesktopMenu();
  const onDesktopChange = (event) => {
    if (event.matches) bindDesktopMenu();
  };
  if (desktopMedia.addEventListener) desktopMedia.addEventListener('change', onDesktopChange);
  else desktopMedia.addListener(onDesktopChange);

  // ---------- Search toggle ----------
  const searchIcon = document.querySelector('.header__gapfy .header__search .search__open');
  const searchInput = document.querySelector(
    '.header__gapfy .header__search .search_input__container'
  );

  if (searchIcon && searchInput) {
    searchIcon.addEventListener('click', () => {
      searchInput.toggleAttribute('open');
      closeDesktopSubmenus();
      searchIcon.setAttribute('aria-expanded', String(searchInput.hasAttribute('open')));
      // Focus the field when opening, for keyboard/UX
      if (searchInput.hasAttribute('open')) {
        const field = searchInput.querySelector('input[type="search"], input[type="text"]');
        if (field) setTimeout(() => field.focus(), 50);
      }
    });
  }
  function closeHeaderSearch() {
    if (!searchInput) return;
    searchInput.removeAttribute('open');
    if (searchIcon) searchIcon.setAttribute('aria-expanded', 'false');
  }
  // O predictive-search pode substituir o conteúdo interno; delegação mantém o
  // fechamento e o estado ARIA corretos mesmo após essa atualização do DOM.
  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('.header__search .search_close')) {
      closeHeaderSearch();
    }
  });
  // Close search with Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchInput && searchInput.hasAttribute('open')) {
      closeHeaderSearch();
      if (searchIcon) searchIcon.focus();
    }
  });

  // ---------- Hide-on-scroll with hysteresis ----------
  const header = document.querySelector('.header__section');
  if (header) {
    let lastScroll = window.scrollY;
    let ticking = false;
    const HIDE_AFTER = 150; // don't hide until scrolled past this
    const DELTA = 8; // ignore jittery sub-pixel scrolls

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          if (Math.abs(y - lastScroll) > DELTA) {
            if (y > lastScroll && y > HIDE_AFTER) {
              header.classList.add('header--hidden');
              closeDesktopSubmenus();
            } else {
              header.classList.remove('header--hidden');
            }
            lastScroll = y;
          }
          ticking = false;
        });
        ticking = true;
      },
      { passive: true }
    );
  }
});
